import { render, staticRenderFns } from "./ListCompetenciesAndUserDefinitions.vue?vue&type=template&id=5bcbf9ba&scoped=true"
import script from "./ListCompetenciesAndUserDefinitions.vue?vue&type=script&lang=js"
export * from "./ListCompetenciesAndUserDefinitions.vue?vue&type=script&lang=js"
import style0 from "./ListCompetenciesAndUserDefinitions.vue?vue&type=style&index=0&id=5bcbf9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbf9ba",
  null
  
)

export default component.exports